module.exports = __webpack_public_path__ + "img/MGH-Nakasu-7-2440x1172.10053980.jpg";